export default {
  CONFLICTS_ADD_CONFLICT: (state, conflict) => {
    if (!conflict || !conflict.differences) {
      console.warn('Invalid conflict data:', conflict);
      return;
    }
    state.conflicts.push(conflict);
  },
  CONFLICTS_REMOVE_CONFLICT: (state, conflictId) => {
    state.conflicts = state.conflicts.filter(
      (c) => c.syncRecord._id !== conflictId
    );
  },
  CONFLICTS_CLEAR_ALL_CONFLICTS: (state) => {
    state.conflicts = [];
  },
};
